import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Disclosure } from '@cred/react-disclosures-sdk'

import Tooltip from 'components/tooltip'

import { tooltipContent, tooltipContentSubject } from './tooltip-content'
import styles from './styles.module.scss'

const AdvertiserDisclosure = ({ theme = 'fox', contentClassName = '' }) => {
  useEffect(() => {
    window.requestAnimationFrame(() => {
      // Send postmessage to SDK so it can adjust box shadow around the widget
      window.parent.postMessage('advertiserDisclosure', '*')
      console.info('[Info] - Dispatch "advertiserDisclosure" postMessage')
    })
  }, [])

  return (
    <div data-testid="advertiser-disclosure" className={styles.container}>
      <Tooltip
        triggerContent="Advertising Disclosure"
        triggerClassName="disclaimer neutral500"
        className={styles.advertiserTooltip}
        contentClassName={contentClassName}
        analyticsOptions={{ contentSubject: tooltipContentSubject[theme] }}
      >
        <div className={styles.copy}>
          <Disclosure required={false} slug={tooltipContent[theme] || ''} />
        </div>
      </Tooltip>
    </div>
  )
}

AdvertiserDisclosure.propTypes = {
  theme: PropTypes.string,
  contentClassName: PropTypes.string,
}

export { AdvertiserDisclosure }

export default AdvertiserDisclosure
